import {GenericContent} from "./GenericContent";
import {Tag} from "../components/generic/BCTag";

export class Reference extends GenericContent {

    referenceItems: ReferenceItem[];
    tags?: Tag[];

    constructor(
        navUrl: string,
        name: string,
        description: string,
        thumbnail: string,
        trackingId: string,
        isPremium: boolean,
        alwaysInRoadmap: boolean,
        referenceItems: ReferenceItem[],
        tags?: Tag[]
    ) {
        super(name, description, thumbnail, navUrl, trackingId, isPremium, alwaysInRoadmap);
        this.referenceItems = referenceItems;
        this.tags = tags;
    }
}

export class ReferenceItem {
    title: string;
    description: string;
    image: string;
    mobileImage: string;
    url: string;
    tags?: Tag[];

    constructor(title: string, description: string, image: string, mobileImage: string, url: string, tags?: Tag[]) {
        this.title = title;
        this.description = description;
        this.image = image;
        this.mobileImage = mobileImage;
        this.url = url;
        this.tags = tags;
    }
}